var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcArrowDownColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6181 0L6.85262 5.1901L2.05833 0.032762L0.867188 1.38798L6.82387 8L12.8672 1.42075L11.6181 0Z",
    fill: "#1A1346"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowDownColor);
export default __webpack_public_path__ + "static/media/ic-arrow-down-color.f7d8e57bd65b292ba9a5bdd6986a9231.svg";
export { ForwardRef as ReactComponent };